import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'

import NotQuiteReady from './internalreview/NotQuiteReady.js'
import ReviewProcessInfo from './internalreview/ReviewProcessInfo'
import InternalReviewBoxes from './internalreview/InternalReviewBoxes'
import Assignment from '../assignment/Assignment'

import {
  getIntlReviewTypeWithContext,
  allRequiredFieldsComplete,
  findRejectedReview
} from '../../../utils/review'
import {
  isInternalReviewer,
  isQuestCopyEditorOrQuestAuthorOrQuestManager,
  isQuestAuthor,
  isQuestManager
} from '../../../utils/user'
import { isNullOrEmpty } from '../../../utils'
import { questIsAssignedByUser } from '../../../utils/assignment'
import {
  pleaseRead,
  belowToFind,
  questsNeedToBeReviewed
} from '../../../utils/messages'
import { messages as labels } from '../../../utils/messages/label'

class InternalReview extends Component {
  constructor(props) {
    super(props)
    this.onAssignClickBound = this.onAssignClick.bind(this)
  }
  render() {
    const {
      quest,
      user,
      organization,
      currentReviews,
      userCanViewInternalReviewInfo,
      questIsInDraftState,
      questIsAssignedToUser,
      intl,
      activities
    } = this.props

    const rejectedReview = findRejectedReview(currentReviews)
    const intlReviewType = getIntlReviewTypeWithContext(
      rejectedReview,
      intl,
      'sentence'
    )
    const reviewMessage = intl.formatMessage(labels.review)
    const embeddedIntlReview = intl.formatMessage(labels.blankReview, {
      reviewType: intlReviewType,
      review: reviewMessage[0].toUpperCase() + reviewMessage.substr(1)
    })
    const rejectedReviewStrong = <strong>{embeddedIntlReview}</strong>

    return (
      <div className="internal-review-container">
        {/* TODO: See if this is still desired for quests that fail during QR; assess design complications */}
        {this.showRejectionInfo() && (
          <div className="rejected-review-info-container">
            <div className="needs-work-icon"></div>
            <h3>
              <FormattedMessage
                id={'Quest.Review.ThisQuestDidNotPass'}
                defaultMessage={
                  'This quest did not pass the required reviews and needs further changes.'
                }
              />
            </h3>
            <p>
              <FormattedMessage
                id={'Quest.Review.PleaseRead'}
                defaultMessage={'{pleaseRead} {strong} {belowToFind}'}
                values={{
                  pleaseRead: pleaseRead,
                  strong: rejectedReviewStrong,
                  belowToFind: belowToFind
                }}
              />
            </p>
          </div>
        )}
        {!isNullOrEmpty(quest.assigned_to) &&
          userCanViewInternalReviewInfo &&
          questIsInDraftState && (
            <Assignment
              quest={quest}
              user={user}
              organization={organization}
              isQuestAuthor={isQuestAuthor(user, quest, organization)}
              questIsAssignedToUser={questIsAssignedToUser}
              questIsAssignedByUser={questIsAssignedByUser(quest, user)}
            />
          )}
        <div className="not-assigned-nor-ready">
          {userCanViewInternalReviewInfo && questIsInDraftState && (
            <p className="guidelines">
              {questsNeedToBeReviewed}
              &nbsp;
              {isQuestCopyEditorOrQuestAuthorOrQuestManager(
                user,
                quest,
                organization
              ) &&
                (questIsAssignedToUser || isNullOrEmpty(quest.assigned_to)) && (
                  <FormattedMessage
                    id={'InternalReview.WhenYoureReadyForReview'}
                    defaultMessage={
                      "When you're ready for review, assign this quest to a reviewer in your organization. (Tip: you can assign this quest to a peer to get feedback at any time.)"
                    }
                  />
                )}
              {(isInternalReviewer(user) || isQuestManager(user)) &&
                questIsAssignedToUser && (
                  <span>
                    &nbsp;
                    <FormattedMessage
                      id={'InternalReview.IfYoureNotTheBestFit'}
                      defaultMessage={"If you're not the best fit,"}
                    />
                    &nbsp;
                    <a onClick={this.onAssignClickBound}>
                      <FormattedMessage
                        id={'InternalReview.AssignThisQuest'}
                        defaultMessage={'assign this quest'}
                      />
                    </a>
                    &nbsp;
                    <FormattedMessage
                      id={'InternalReview.ToADifferentReviewer'}
                      defaultMessage={'to a different reviewer.'}
                    />
                  </span>
                )}
            </p>
          )}
          {userCanViewInternalReviewInfo &&
            !allRequiredFieldsComplete(quest, activities) &&
            questIsInDraftState && <NotQuiteReady />}
          {userCanViewInternalReviewInfo &&
            (allRequiredFieldsComplete(quest, activities) ||
              !isNullOrEmpty(quest.reviewing_compiled_quest)) && (
              <InternalReviewBoxes
                user={user}
                quest={quest}
                organization={organization}
                handleAssignClick={this.props.handleAssignClick}
                dispatch={this.props.dispatch}
                approvals={this.props.approvals}
                toQualityReviewModalIsOpen={
                  this.props.toQualityReviewModalIsOpen
                }
                isEditingApproval={this.props.isEditingApproval}
                isSettingLastApproval={this.props.isSettingLastApproval}
              />
            )}
        </div>
        {!userCanViewInternalReviewInfo && <ReviewProcessInfo />}
      </div>
    )
  }

  showRejectionInfo() {
    const { user, quest, organization } = this.props
    return (
      quest.reviewing_compiled_quest &&
      quest.reviewing_compiled_quest.state === 'rejected' &&
      isQuestCopyEditorOrQuestAuthorOrQuestManager(user, quest, organization)
    )
  }

  onAssignClick() {
    this.props.handleAssignClick()
  }
}

InternalReview.propTypes = {
  quest: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  currentReviews: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired,
  handleAssignClick: PropTypes.func.isRequired,
  approvals: PropTypes.array,
  toQualityReviewModalIsOpen: PropTypes.bool.isRequired,
  userCanViewInternalReviewInfo: PropTypes.bool.isRequired,
  questIsInDraftState: PropTypes.bool.isRequired,
  questIsAssignedToUser: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  isEditingApproval: PropTypes.bool.isRequired,
  isSettingLastApproval: PropTypes.bool.isRequired,
  activities: PropTypes.array.isRequired
}

export default injectIntl(InternalReview)



// WEBPACK FOOTER //
// ./src/components/quest/review/InternalReview.js